import * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveLineItemMutationVariables = Types.Exact<{
  invoiceNumber: Types.Scalars['String'];
  chargeId: Types.Scalars['Int'];
}>;


export type RemoveLineItemMutation = { __typename?: 'MutationModel', invoices?: { __typename?: 'InvoiceMutationModel', removeCharge?: { __typename?: 'ValidationResponse', errors?: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string } | null> | null } | null } | null };


export const RemoveLineItemDocument = gql`
    mutation RemoveLineItem($invoiceNumber: String!, $chargeId: Int!) {
  invoices {
    removeCharge(invoiceNumber: $invoiceNumber, chargeId: $chargeId) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type RemoveLineItemMutationFn = Apollo.MutationFunction<RemoveLineItemMutation, RemoveLineItemMutationVariables>;

/**
 * __useRemoveLineItemMutation__
 *
 * To run a mutation, you first call `useRemoveLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLineItemMutation, { data, loading, error }] = useRemoveLineItemMutation({
 *   variables: {
 *      invoiceNumber: // value for 'invoiceNumber'
 *      chargeId: // value for 'chargeId'
 *   },
 * });
 */
export function useRemoveLineItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLineItemMutation, RemoveLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLineItemMutation, RemoveLineItemMutationVariables>(RemoveLineItemDocument, options);
      }
export type RemoveLineItemMutationHookResult = ReturnType<typeof useRemoveLineItemMutation>;
export type RemoveLineItemMutationResult = Apollo.MutationResult<RemoveLineItemMutation>;
export type RemoveLineItemMutationOptions = Apollo.BaseMutationOptions<RemoveLineItemMutation, RemoveLineItemMutationVariables>;